import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { testIds } from '@/lib/test-ids'
import type { QuizSelection } from '@/lib/api/quiz'

export function formatQuizSessionScope(selection?: QuizSelection | null): string {
  const domains = (selection?.domains || []).filter(Boolean)
  if (domains.length === 0) return 'All domains'
  return domains.map((d) => d.replace(/_/g, ' ')).join(', ')
}

type QuizSessionHeaderProps = {
  mode: 'practice' | 'quiz'
  scopeLabel: string
  onExitSession: () => void
  disabled?: boolean
}

/**
 * Persistent session chrome: mode + domain scope + Exit session.
 * Wireframe: /?test=quiz-domain-escape
 */
export function QuizSessionHeader({
  mode,
  scopeLabel,
  onExitSession,
  disabled = false,
}: QuizSessionHeaderProps) {
  return (
    <div
      className="flex flex-wrap items-center gap-2 px-5 py-2 border-b border-border bg-muted/40 shrink-0"
      data-testid={testIds.quizDocumentRenderer.sessionHeader}
    >
      <Badge variant="outline" className="text-xs">
        {mode === 'practice' ? 'Practice' : 'Quiz'}
      </Badge>
      <span
        className="text-sm font-medium truncate min-w-0"
        data-testid={testIds.quizDocumentRenderer.sessionScope}
      >
        {scopeLabel}
      </span>
      <div className="flex-1" />
      <Button
        type="button"
        size="sm"
        variant="ghost"
        className="h-7 text-xs"
        disabled={disabled}
        onClick={onExitSession}
        data-testid={testIds.quizDocumentRenderer.exitSession}
      >
        Exit session
      </Button>
    </div>
  )
}
